import React from "react";
import { Link, RichText } from "prismic-reactjs";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import CustomCarousel from "../components/Carousel";
import linkResolver from "../helpers/linkResolver";
import isValidLink from "../helpers/isValidLink";

export default function RenderProductsSection(slice) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("768"));

  const backgroundStyle = {
    background: slice.primary.background_color,
    color: slice.primary.text_color,
  };

  const ctaText = slice.primary.cta_text;
  const ctaLink = slice.primary.cta_link;

  const renderProductsList = (items) => {
    return items.map((el, i) => {
      const ctaText = el.cta_text;
      const ctaLink = el.cta_link;
      const richContent = el.rich_content;

      const spaceOut = el.space_out;
      const backgroundColor = el.background_color;

      const style = {
        backgroundColor: backgroundColor
      }

      return (
        <div key={i} className={`product ${spaceOut && "extra-padding"} ${backgroundColor && "solid-background"}`} style={style}>
          <div className="image">
            <img src={el.image.url} alt="Products" />
          </div>
          <div className="rich-text center-align">
            <RichText render={richContent}/>
          </div>

          {isValidLink(ctaLink, ctaText) && (
            <div className="content center-align">
              <a href={Link.url(ctaLink, linkResolver)} className="button">
                {ctaText[0].text}
              </a>
            </div>
          )}
        </div>
      );
    });
  };
  return (
    <section
      className="product-section standard-padding gray-headlines-and-copy"
      style={backgroundStyle}
    >
      <div className="wrapper">
        <div className="content-wrapper">
          <RichText render={slice.primary.content} />
          {isValidLink(ctaLink, ctaText) && (
            <div className={`button-wrapper ${slice.primary.cta_alignment}`}>
              <a
                href={Link.url(slice.primary.cta_link, linkResolver)}
                className={`button solid-black`}
              >
                {slice.primary.cta_text[0].text}
              </a>
            </div>
          )}
        </div>

        {isMobile ? (
          <div className="hero-carousel hide-thumbs hide-indicators animate">
            <CustomCarousel items={slice.items} indicators={false} />
          </div>
        ) : (
          <div className="products-wrapper animate custom-animation">
            {renderProductsList(slice.items)}
          </div>
        )}
      </div>
    </section>
  );
}
